import React from "react";

import { ReactComponent as ErrorIcon } from "../../../../assets/img/error-icon.svg";
// import { ReactComponent as KudaMiniIcon } from "../../../../assets/icons/KudaMiniIcon.svg";
import { ReactComponent as SmsMiniIcon } from "../../../../assets/icons/SmsMiniIcon.svg";
import { ReactComponent as EmailMiniIcon } from "../../../../assets/icons/emailMiniIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/icons/ArrowRightIcon.svg";

import { IconWrap, KudaAction, ValidateLoginContainer } from "../../views/signIn/styles";
import UrlCorrectionBox from "../../components/UrlCorrectionBox";
import { StyledPersonalAuthentication } from "../../../../styles/PersonalAuthentication";

const PhoneValidationOptions = ({
    title,
    subtitle,
    sendValidationLoading,
    showSendValidationError,
    validationErrMsg,
    sendValidationMsg,
}) => {
    return (
        <div className="flex login-container--wrap">
            <ValidateLoginContainer>
                <div className="kuda-auth--layout">
                    <div className="auth-container">
                        <div className="animated kudaFadeInUp">
                            <h1 className="page-heading-title">{title}</h1>
                        </div>

                        <div className="width-100">
                            <div
                                className={`infinite-path width-wide mt-0
                                ${!sendValidationLoading ? "d-none" : ""}
                                    `}
                            >
                                <span id="elem" className="shape trail"></span>
                            </div>

                            <div className="flex align-start justify-between">
                                <StyledPersonalAuthentication
                                    className={`width-100 position-relative ${
                                        sendValidationLoading ? "disabled" : ""
                                    }`}
                                >
                                    <div className="auth-header">
                                        <p className="text-sm color-primary text-center mx-auto">
                                            {subtitle}
                                        </p>
                                    </div>

                                    {showSendValidationError && (
                                        <div className="error-auth--label mt-4">
                                            <span className="auth-error-icon">
                                                <ErrorIcon />
                                            </span>
                                            <span className="auth-error-text">
                                                {validationErrMsg}
                                            </span>
                                        </div>
                                    )}

                                    <KudaAction
                                        className="mt-40"
                                        onClick={() => {
                                            sendValidationMsg(3);
                                        }}
                                    >
                                        <IconWrap>
                                            <EmailMiniIcon />
                                        </IconWrap>
                                        <div className="login__otp-text-wrap">
                                            <div className="action-title">By Email</div>
                                            <div className="action-subtitle whitespace-nowrap">
                                                We’ll send a code to your email address.
                                            </div>
                                        </div>
                                        <div>
                                            <ArrowRightIcon />
                                        </div>
                                    </KudaAction>

                                    <KudaAction
                                        onClick={() => {
                                            sendValidationMsg(2);
                                        }}
                                    >
                                        <IconWrap>
                                            <SmsMiniIcon />
                                        </IconWrap>
                                        <div className="login__otp-text-wrap">
                                            <div className="action-title">By SMS</div>
                                            <div className="action-subtitle whitespace-nowrap">
                                                We’ll send a code to your Kuda phone number.
                                            </div>
                                        </div>
                                        <div>
                                            <ArrowRightIcon />
                                        </div>
                                    </KudaAction>

                                    {/* <KudaAction>
                                        <div className="disabled-grey">
                                            <KudaMiniIcon />
                                        </div>
                                        <div className="ml-3 disabled-grey">
                                            <div className="action-title">With the Kuda App</div>
                                            <div className="action-subtitle">
                                                Complete this sign in with your Kuda mobile app.
                                            </div>
                                        </div>
                                        <div className="disabled-grey">
                                            <ArrowRightIcon />
                                        </div>
                                    </KudaAction> */}

                                    <UrlCorrectionBox className="mt-4" />
                                </StyledPersonalAuthentication>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidateLoginContainer>
        </div>
    );
};

export default PhoneValidationOptions;
